export * from './authorized-pages.component'